// extracted by mini-css-extract-plugin
export var album_button = "xlnt-records-module--album_button--MsZrk";
export var album_content_wrapper = "xlnt-records-module--album_content_wrapper--e6CTD";
export var album_description = "xlnt-records-module--album_description--LdCAn";
export var album_image_wrapper = "xlnt-records-module--album_image_wrapper--FqH51";
export var album_wrapper = "xlnt-records-module--album_wrapper--QvNau";
export var albums_background = "xlnt-records-module--albums_background--z6Igu";
export var albums_content_wrapper = "xlnt-records-module--albums_content_wrapper--MJ7HQ";